
import axios from "axios";
import { useEffect, useState } from "react";

export function useSolPrice() {
    const [solPrice, setSolPrice] = useState(null)

    const endpoint = process.env.REACT_APP_SOL_PRICE_ENDPOINT
  
    const getSolPrice = async () => {
        try {
            const price = await axios.get('https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd').then((res) => res.data)
            setSolPrice(price.solana.usd)
        } catch (error) {
            console.error("Transaction failed", error);
        }
    }

    useEffect(() => {
        if (endpoint) {
            getSolPrice()
        }
    }, [])
    return { solPrice }
}
